<dx-box
    #projectTasksBox
    height="100%"
    width="100%"
    direction="col"
    class="cc-search-grid-container"
    [elementAttr]="{ id: 'projectTasksBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1">
        <cc-data-grid-features
            #gridFeatures
            [stateConfig]="{ storageKey: 'PROJECT_TASKS_SEARCH_GRID', storeGroupings: true }"
            [gridFeatures]="{ allowGrouping: true }"
            [dataSource]="projectTasks"
        >
            <dx-data-grid appHasInternalUserColumns width="100%" height="100%" [dataSource]="projectTasks">
                <dxo-search-panel [text]="searchText"></dxo-search-panel>
                <dxi-column dataField="location" caption="Location" dataType="string"></dxi-column>
                <dxi-column
                    dataField="community"
                    dataType="string"
                    caption="Community"
                    cellTemplate="communityTemplate"
                    groupCellTemplate="groupCellTemplate"
                ></dxi-column>
                <dxi-column dataField="taskId" dataType="number" caption="Task ID"></dxi-column>

                <dxi-column dataField="taskDescription" dataType="string" caption="Item"></dxi-column>
                <dxi-column
                    dataField="responsibleDisplayText"
                    dataType="string"
                    caption="Responsible"
                    cellTemplate="responsibleUserTemplate"
                ></dxi-column>
                <dxi-column dataField="status" dataType="string" caption="Status"></dxi-column>
                <dxi-column dataField="dueDate" dataType="date" caption="Due Date" [format]="dateFormat"></dxi-column>
                <dxi-column
                    name="InternalNotes"
                    dataField="hasItemNotes"
                    dataType="boolean"
                    caption="Notes"
                    alignment="center"
                    cellTemplate="notesTemplate"
                ></dxi-column>
                <dxi-column
                    name="InternalLogs"
                    caption="Log"
                    alignment="center"
                    [width]="70"
                    cellTemplate="logTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="notes"
                    dataType="string"
                    caption="Description"
                    [width]="200"
                    cellTemplate="descriptionTemplate"
                ></dxi-column>

                <div *dxTemplate="let data of 'notesTemplate'">
                    <div *ngIf="data.data.hasItemNotes">
                        <i
                            class="cc-1-5x cc-icon-content cc-icon-check cc-hyperlink"
                            [ngClass]="iconNotes"
                            (click)="onNotesClick(data.data)"
                        ></i>
                    </div>
                    <div *ngIf="!data.data.hasItemNotes">
                        <i
                            class="cc-1-5x dx-theme-accent-as-text-color cc-hyperlink"
                            [ngClass]="iconEmptyNotes"
                            (click)="onNotesClick(data.data)"
                        ></i>
                    </div>
                </div>

                <div *dxTemplate="let cell of 'responsibleUserTemplate'">
                    <app-user-bio-link
                        [user]="cell.data.responsible"
                        [communityId]="cell.data.communityId"
                    ></app-user-bio-link>
                </div>

                <div *dxTemplate="let cell of 'communityTemplate'">
                    <app-property-community-link
                        [communityId]="cell.data.communityId"
                        [displayText]="cell.value"
                    ></app-property-community-link>
                </div>

                <div *dxTemplate="let data of 'descriptionTemplate'">
                    <app-hyperlink-creator
                        cssClass="description-text"
                        mode="hyperlinkOnly"
                        [displayText]="data.value | slice: 0:30"
                        (onLinkClick)="toggleDescription(data)"
                    ></app-hyperlink-creator>
                    <span *ngIf="data.value && data.value.length > 30">...</span>
                    <div *ngIf="data.rowIndex === gridRowIndex && showDescription" class="description-long-text">
                        {{ data.value }}
                    </div>
                </div>

                <div *dxTemplate="let data of 'logTemplate'">
                    <div class="link-content cc-hyperlink">
                        <i
                            class="cc-1-5x dx-theme-accent-as-text-color"
                            [ngClass]="iconLog"
                            (click)="onLogClick(data.data)"
                        ></i>
                    </div>
                </div>

                <div *dxTemplate="let groupdata of 'groupCellTemplate'">
                    <div class="community-group">
                        Community:&nbsp;
                        <app-property-community-link
                            [communityId]="getCommunityId(groupdata.data)"
                            [displayText]="groupdata.value"
                        ></app-property-community-link>
                    </div>
                </div>

                <dxo-summary>
                    <dxi-group-item column="taskId" summaryType="count" displayFormat="Count = {0}"></dxi-group-item>
                </dxo-summary>
            </dx-data-grid>
        </cc-data-grid-features>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#projectTasksBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-search-notes-editor
    #notesEditor
    *ngIf="showNotesEditor"
    [visible]="showNotesEditor"
    [previousNotes]="previousNotes"
    [taskId]="projectTaskNotesParam.projectTaskId"
    (onNoteSave)="onNoteSave($event)"
    (onNotesEditorClose)="onNotesEditorClose()"
></app-search-notes-editor>

<app-search-transaction-log
    *ngIf="showTransactionLog"
    [visible]="showTransactionLog"
    [logId]="projectTaskHistoryParam.processId"
    [communityId]="projectTaskHistoryParam.communityId"
    [transactionLogData]="transactionLogData"
    [columnDef]="projectTaskColumnDef"
    (onCloseClick)="onTransactionLogclose()"
></app-search-transaction-log>
